import { sub } from 'date-fns/sub'
import * as z from 'zod'

import { MIN_ENTRY_AGE_WEEKS } from '@flows/configs/petHealthV2/constants'
import {
  NATIVE_TITLE_SIZE,
  v2InfoModal,
  v2Text,
  v2TextWithPetName,
} from '@flows/configs/petHealthV2/steps/elements/shared'
import * as schemaUtils from '@flows/configs/shared/schemaUtils'
import type { ElementFragment } from '@flows/configs/shared/stepFragments'
import type { StepConfigParams } from '@flows/configs/types'
import { t } from '@flows/core/i18n'
import { BaseSchema_PetHealthV2GetsafeDe } from '@flows/insurance/schemas'

export const petBirthdayElements = (params: StepConfigParams) =>
  ({
    elements: [
      {
        type: 'title',
        text: v2TextWithPetName(params, 'steps.pet_birthday.title'),
        size: NATIVE_TITLE_SIZE,
        infoButton: v2InfoModal('steps.pet_birthday'),
      },
      {
        type: 'date',
        shouldTrackValues: true,
        name: params.helperFunctions.getParamPath('pet_born_on'),
      },
      {
        type: 'checkbox',
        noBackground: true,
        fields: [
          {
            name: params.helperFunctions.getTransientPath('pet_birthday_unknown'),
            title: v2Text('steps.pet_birthday.unknown'),
            isOptional: true,
          },
        ],
      },
    ],
    schema: schemaUtils
      .generateZodObjectFromPaths({
        [params.helperFunctions.getParamPath('pet_born_on')]: z.coerce
          .date()
          .refine(
            (bornOn) => bornOn <= sub(new Date(), { weeks: MIN_ENTRY_AGE_WEEKS }),
            () => ({
              message: t('sharedFlows_petHealthV2:steps.pet_birthday.minAge', {
                weeks: MIN_ENTRY_AGE_WEEKS,
              }),
            })
          )
          .pipe(BaseSchema_PetHealthV2GetsafeDe.shape.pet_born_on),
      })
      .merge(
        schemaUtils
          .generateZodObjectFromPaths({
            [params.helperFunctions.getTransientPath('pet_birthday_unknown')]: z
              .boolean()
              .optional(),
          })
          .partial()
      ),
  }) as const satisfies ElementFragment
